export const isCustomRole = (roleId: number) => {
  return roleId >= 1_000_000
}
